module.exports = global["$"] = require("-!D:\\a\\1\\s\\Web\\CMS\\App_Themes\\Safestore\\js\\lib\\jquery-3.5.1.min.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?$!./js/lib/jquery-3.5.1.min.js
 ** module id = 98
 ** module chunks = 24
 **/